import { tradingApi } from './tradingApi';

export interface AppResult {
  category: 'watchlist' | 'portfolio' | 'alert' | 'analysis' | 'trade' | 'banker_lead' | 'knowledge' | 'ipo';
  symbol?: string;
  name?: string;
  description?: string;
  url: string;
}

export interface MarketResult {
  code: string;
  name: string;
  exchange: string;
  type: string;
  country?: string;
}

export interface WebResult {
  title: string;
  snippet: string;
  url: string;
}

export interface SearchResponse {
  query: string;
  app_results: AppResult[];
  market_results: MarketResult[];
  web_results: WebResult[];
}

export async function globalSearch(q: string): Promise<SearchResponse> {
  const { data } = await tradingApi.get<SearchResponse>(`/search?q=${encodeURIComponent(q)}`);
  return data;
}
